module.exports = __webpack_public_path__ + "img/twitter.3b857422.png";